import React, { useState } from "react";
import axios from 'axios';
import { message } from 'antd';
import ENVIRONMENT from '../../../../environments';

const ShopifyAuthCard = () => {
    const isAuthorized = localStorage.getItem('shopify_authorized') === 'true';
    const shop = localStorage.getItem('shopify_shop');
    const [disconnecting, setDisconnecting] = useState(false);

    const handleInstallClick = () => {
        window.open('https://apps.shopify.com/all3d', '_blank');
    };

    const handleDisconnect = async () => {
        setDisconnecting(true);
        try {
            const response = await axios.post(ENVIRONMENT.SHOPIFY_DISCONNECT, {
                username: localStorage.getItem('username')
            });
            if (response.status === 200) {
                localStorage.removeItem('shopify_authorized');
                localStorage.removeItem('shopify_shop');
                message.success("Successfully disconnected from Shopify");
                window.location.reload();
            }
        } catch (error) {
            console.error("Error disconnecting from Shopify:", error);
            message.error("Failed to disconnect from Shopify");
        }
        setDisconnecting(false);
    };

    return (
        <div className="integration-card">
            <p className="manrope f-24">Authorize to Shopify</p>
            <img
                style={{ margin: "unset", width: 120, height: 40, objectFit: "contain", display: "block", margin: "24px auto" }}
                src={require("../../../../assets/images/shopify-logo-2018.svg")}
                alt="shopify-logo"
            />
            <p className="manrope f-14 mt-40" style={{ marginTop: "60px" }}>
                Install ALL3D app from the Shopify App Store to get started.
            </p>

            {isAuthorized ? (
                <div>
                    <p className="manrope f-14" style={{ color: '#52c41a', marginBottom: '16px' }}>
                        Connected to {shop}
                    </p>
                    <button
                        className="disconnect-button"
                        onClick={handleDisconnect}
                        disabled={disconnecting}
                    >
                        {disconnecting ? "Disconnecting..." : "Disconnect"}
                    </button>
                </div>
            ) : (
                <button
                        className="auhtorize-button"
                        onClick={handleInstallClick}
                >
                        Install App
                </button>
            )}
        </div>
    );
};

export default ShopifyAuthCard;
